import cx from 'classnames';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isMenuCollapsed } from '../../../apollo/cache';

/**
 * @typedef {object} NavigationLinkProps
 * @property {string} children
 * @property {string} to
 * @property {string} [className]
 * @property {string} [activeLink]
 * @property {boolean} [collapse]
 */

/**
 * @param {NavigationLinkProps} props
 */
const NavigationLink = props => {
  const { children, to, className, activeLink, collapse = true } = props;

  const { pathname } = useLocation();
  const linkClasses = [className];
  if (pathname === to || (activeLink && pathname.includes(activeLink))) {
    linkClasses.push('active');
  }

  const handleClicking = () => isMenuCollapsed(collapse);

  return (
    <Link onClick={handleClicking} to={to} className={cx(linkClasses)}>
      <div className='navigation-menu__label'>{children}</div>
    </Link>
  );
};

export default NavigationLink;
